export default __webpack_public_path__ + "static/media/gym.33d690c9.svg";